package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLuckyleaf2026Page(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/luckyleaf2026.md", FrontMatterElement.Builder { addScalar("title", "Green Rebates Is Back At Lucky Leaf!"); addScalar("description", "Oh Minnesota, how we’ve missed you and your Midwest hospitality. What we love most about taking trips to Minnesota is connecting with the cultivators of tomorrow."); addScalar("author", "Ethan Cohen"); addScalar("date", "2026-02-24"); addScalar("updated", "2026-02-24"); addScalar("image", "/images/blog/luckyleaf2026eventpromo.jpg"); addList("tags") { addScalar("Big Incentives"); addScalar("Big Rebates"); addScalar("Cost Savings"); }; }))
}

@Page("/blog/green-rebates-is-back-at-lucky-leaf")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Luckyleaf2026Page() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("green-rebates-is-back-at-lucky-leaf") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Green Rebates Is Back At Lucky Leaf!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Oh Minnesota, how we’ve missed you and your Midwest hospitality. The last time we were there, FreeMoney snuck backstage during Afroman’s Legacy Cup performance. All he wanted to do was ask Afroman if he knew about the incredible rebate program in Minneapolis. Afroman said he’d look into it, but then he got high.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Lucky Leaf 2025 was the first time we hosted our podcast in the Twin Cities, leaving us impressed by the wisdom imparted by the experts who grabbed the mic. Cat Franklin, Michigan Matt, and Will Batt were three of our top guests, all of whom expressed the importance of welcoming failure in the early days of cultivation. After filming over 40 podcasts, we’ve noticed a common pattern among cannabis pros: passion and resilience are the two most important factors that determine success. Tom Brady didn’t win a Super Bowl his first year. It was his second. Then his fourth and fifth, but who’s counting?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("What we love most about taking trips to Minnesota is connecting with the cultivators of tomorrow. While many folks are frustrated with the sluggish and disorganized rollout, most are simply excited to begin their weed-growing journey and share the plant with their beloved Midwestern kinfolk. At Green Rebates, our mission is to tell these cultivators about the jaw-dropping rebate programs that exist in their state, specifically through Xcel Energy. Xcel has millions of dollars in rebates for LEDs, HVAC, dehumidifiers, and much more.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now let’s talk about Lucky Leaf. Anybody who knows Green Rebates is aware of our trade show shenanigans. Most companies hand out business cards and call it a day. We give away cash and provide experiences. We’re basically a traveling Dave & Buster’s.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This year, we decided to roll out the first-ever Rebate Olympics.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Come to Booth 306 to play Flappy Bird, Boxing, Cornhole, and Beer Pong. We tally up your scores, and the top five get invited back to compete for bronze, silver, and gold medals. If you’re one of those people who is only good at those four things, this is your time to shine. Lugging arcade games across the country isn’t easy, and it isn’t cheap, but we know it will be worth it when the great people of Minnesota get to compete for gold.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks for making it this far into our blog. I hope I didn’t ramble too much and was at least halfway entertaining. We can’t wait to make more memories with y’all at Lucky Leaf. Come by our booth to play games and talk rebates for your horticulture facility. We give cash for LEDs, HVAC, dehumidifiers, and much more.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To learn more, check out our main site ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com") {
            org.jetbrains.compose.web.dom.Text("GreenRebates.com")
        }
        org.jetbrains.compose.web.dom.Text(" and let’s get that rebate estimated for ya!")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/lucky-leaf-2026") {
                org.jetbrains.compose.web.dom.Text("Lucky Leaf 2026 Recap | We’re Lucky To Be Here")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/the-2026-guide-to-cannabis-rebates-how-to-get-paid-for-your-grow-upgrades") {
                org.jetbrains.compose.web.dom.Text("The 2026 Guide to Cannabis Rebates: How to Get Paid for Your Grow Upgrades")
            }
        }
    }
}
